export const MEDIA_IMAGE_BOOSTER_ORIGIN = 'ai_tool_panel';
